import { API_BASE_URL } from '../../services/config';

let cachedCsrfToken: string | null = null;

function readCookie(name: string) {
  const escapedName = name.replace(/[-/\\^$*+?.()|[\]{}]/g, "\\$&");
  const match = document.cookie.match(new RegExp(`(?:^|; )${escapedName}=([^;]*)`));
  const value = match?.[1];
  return value ? decodeURIComponent(value) : null;
}

export function clearCsrfTokenCache() {
  cachedCsrfToken = null;
}

export function cacheCsrfToken(token: string) {
  cachedCsrfToken = token;
}

export function getCachedCsrfToken() {
  const fromCookie = readCookie("tam_csrf_token");
  if (fromCookie) {
    // Prefer cookie value in case token was rotated server-side (e.g., after login).
    cachedCsrfToken = fromCookie;
    return fromCookie;
  }

  if (cachedCsrfToken) {
    return cachedCsrfToken;
  }

  return null;
}

export async function ensureCsrfToken(signal?: AbortSignal) {
  const existing = getCachedCsrfToken();
  if (existing) {
    return existing;
  }

  const response = await fetch(`${API_BASE_URL}/api/auth/csrf-token`, {
    ...(signal ? { signal } : {}),
    method: "GET",
    credentials: "include",
    headers: {
      "X-Requested-With": "XMLHttpRequest",
    },
  });

  if (!response.ok) {
    throw new Error("Unable to initialize CSRF protection");
  }

  const payload = (await response.json()) as {
    data?: { csrfToken?: string };
    csrfToken?: string;
  };

  const csrfToken = payload.data?.csrfToken || payload.csrfToken || readCookie("tam_csrf_token");

  if (!csrfToken) {
    throw new Error("CSRF token missing from server response");
  }

  cachedCsrfToken = csrfToken;
  return csrfToken;
}
